<template functional>
  <div :class="['Loader', props.theme, data.class, data.staticClass]" />
</template>

<script>
export default {
  props: {
    theme: String,
  },
}
</script>

<style lang="scss">
/* stylelint-disable unit-whitelist */
$_radius-sm: 1em;
$_radius-md: 2em;
$_radius-lg: 4em;
/* stylelint-enable unit-whitelist */
$_color: $main;
$_opacity: 0.2;
$_color-trans: rgba($_color, $_opacity);

@-webkit-keyframes load8 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes load8 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.Loader {
  animation: load8 0.8s infinite linear;
  border-left-color: $_color;
  border-style: solid;
  border-width: ($_radius-md / 10);
  color: $_color-trans;
  font-size: 1rem;
  margin: 0 auto;
  position: relative;
  text-indent: -9999rem;
  transform: translateZ(0);

  &, &::after {
    border-radius: 50%;
    height: $_radius-md;
    width: $_radius-md;
  }

  // ----------------- Sizes -----------------
  &.lg {
    border-width: ($_radius-lg / 14);

    &, &::after {
      height: $_radius-lg;
      width: $_radius-lg;
    }
  }

  &.sm {
    border-width: ($_radius-sm / 14);

    &, &::after {
      height: $_radius-sm;
      width: $_radius-sm;
    }
  }

  // ----------------- Themes -----------------
  &.success {
    border-left-color: $success;
  }

  &.info {
    border-left-color: $info;
  }
}
</style>
